import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import Divider from "@material-ui/core/Divider";
import Slide from "@material-ui/core/Slide";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";

import Avatar from "@material-ui/core/Avatar";

import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import ClassAddDetailsLocation from "./ClassAddDetailsLocation";
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function ElevationScroll(props) {
	const { children, target, onElevationChange } = props; // `target` is a ref to the scrollable element
	const [elevated, setElevated] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (target.current) {
				const isElevated = target.current.scrollTop > 70;
				setElevated(isElevated);
				onElevationChange(isElevated);
			}
		};

		const scrollableElement = target.current;
		scrollableElement.addEventListener("scroll", handleScroll);

		return () => {
			scrollableElement.removeEventListener("scroll", handleScroll);
		};
	}, [target, onElevationChange]);

	// Define custom elevation styles
	const elevationStyle = elevated
		? {
				boxShadow: "0 2px 4px 0 rgba(13,22,25,.058)",
				backgroundColor: "#FFF",
		  }
		: {
				boxShadow: "none",
		  };

	// Apply custom styles to the children component
	return React.cloneElement(children, {
		style: { ...children.props.style, ...elevationStyle },
	});
}

const ClassAddDetails = ({ open, onClose, ...props }) => {
	const classes = useStyles("BookingFunnel");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	const itemsToShow = fullScreen ? 3 : 3;

	const hasOptions = false;

	const dialogContentRef = React.useRef(null);

	const [isElevated, setIsElevated] = useState(false);

	const handleElevationChange = (elevated) => {
		setIsElevated(elevated);
	};

	const serviceOptions = [
		{
			duration: "Free trial offer",
			detail: "New students only",
			price: "Free",
		},
		{
			duration: "Drop-in",
			detail: "9 dates remaining",
			price: "$25 / class",
		},
		{
			duration: "Monthly pricing",
			detail: "Sep 6, 2023 – May 22, 2024",
			price: "$65 / month",
		},
		{
			duration: "Remaining schedule",
			detail: "Sep 6, 2023 – May 22, 2024",
			price: "$250",
		},
		{
			duration: "Full schedule",
			detail: "Sep 6, 2023 – May 22, 2024",
			price: "$350",
		},
	];

	const itemData = [
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--XXgODZkV--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/5JhoFGHSQ/IMG_2058.jpg",
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--C2KGRIZd--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/b6hxCnRM/6176e93491123974bf53a923_1_pictures.jpg",
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--Y9udUVtL--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/BSYJytWI7_/IMG_2056.jpg",
		},
		{
			img: "https://res.cloudinary.com/liaison-inc/image/upload/s--Md7vbIBI--/c_scale,f_webp,q_auto,w_1800/v1/lessons/user-media/prod/approved/provider/6176e93491123974bf53a923/portfolio/b6hxCnRM/6176e93491123974bf53a923_3_pictures.jpg",
		},
	];

	const [selectedOption, setSelectedOption] = useState(null);

	const handleRadioChange = (event) => {
		setSelectedOption(event.target.value);
	};

	//

	const handleCloseClick = () => {
		onClose(); // Call the onClose function passed as a prop
	};

	//
	

	return (
		<>
			{/* <Box mb={10}>
				<ImageList rowHeight={130} gap={8} cols={fullScreen ? 3 : 3}>
					{itemData.slice(0, itemsToShow).map((item) => (
						<ImageListItem
							key={item.img}
							cols={1}
							className={classes.imageList}
							classes={{ item: classes.imageList }}
						>
							<img src={item.img} />
						</ImageListItem>
					))}
				</ImageList>
			</Box> */}
			<Box
				fontWeight={600}
				fontSize={22}
				pb={1}
				maxWidth={"90%"}
				lineHeight={1.3}
			>
				Class experience
			</Box>
			<Box py={4}>
				<>
					<Box maxWidth={"100%"}>
						<div className={classes.serviceDialogText}>
							<div class="SAMPLE HTML OUTPUT">
								<p>
									Yoga, music, art projects and sensory play. A peaceful,
									playful hour for you and your child.&nbsp;
								</p>
								<p>
									Yoga, music, art projects and sensory play. A peaceful,
									playful hour for you and your child.Yoga, music, art projects
									and sensory play. A peaceful, playful hour for you and your
									child.
								</p>
								<p>
									Yoga, music, art projects and sensory play. A peaceful,
									playful hour for you and your child.&nbsp;
								</p>
								<p>
									Yoga, music, art projects and sensory play. A peaceful,
									playful hour for you and your child.Yoga, music, art projects
									and sensory play. A peaceful, playful hour for you and your
									child.
								</p>
							</div>
						</div>
					</Box>

					<div>
						<Box my={8}>
							<Divider light />
						</Box>
						<Box
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							mb={8}
						>
							<div>
								<Box fontSize={22} fontWeight={600}>
									Other things to know
								</Box>
							</div>
						</Box>
						<Box mb={6}>
							<Box fontWeight={600} fontSize={17} mb={1}>
								Cancellation policy
							</Box>
							<div className={classes.serviceDialogText}>
								Written notice must be given on or before the last open office
								day of the month in order to avoid a non-refundable charge to
								your account.{" "}
							</div>
						</Box>

						<Box mb={6}>
							<Box fontWeight={600} fontSize={17} mb={1}>
								Holiday schedule
							</Box>
							<Link color="primary">See schedule</Link>
						</Box>
					</div>

					<div>
						<Box my={8}>
							<Divider light />
						</Box>
						<Box
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							mb={4}
						>
							<div>
								<Box fontSize={22} fontWeight={600}>
									Location & hours
								</Box>
							</div>
						</Box>
						<ClassAddDetailsLocation />
					</div>

					<div>
						<Box my={8}>
							<Divider light />
						</Box>
						<Box
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							mb={4}
						>
							<div>
								<Box fontSize={22} fontWeight={600}>
									Meet the team
								</Box>
							</div>
						</Box>
						<Box display={"flex"} flexDirection={"column"} style={{ gap: 40 }}>
							<Box display={"flex"} style={{ gap: 16 }}>
								<Avatar
									variant="rounded"
									alt={"persona name"}
									src={
										"https://res.cloudinary.com/liaison-inc/image/upload/s--rIs1yYOM--/c_fill,f_webp,h_400,q_auto,w_400/v1/trustedcare/user-media/prod/approved/provider/655872e3ad2b40198d5966bf/profile/gC90r8KhW/563D9629-C5AB-432B-8EBA-DB107DD1059C.JPG"
									}
									imgProps={{ loading: "lazy", decoding: "async" }}
									style={{ width: 80, height: 80 }}
								>
									AS
								</Avatar>
								<Box
									display={"flex"}
									flexDirection={"column"}
									style={{ gap: 2 }}
								>
									<Box fontWeight={600} fontSize={18} mb={1}>
										Rachel R.
									</Box>

									<Box fontSize={16} lineHeight={1.5}>
										A magical place for families to connect through yoga, art
										and play! Classes, camps, drop-in play time and parties for
										babies and up. A magical place for families to connect
										through yoga, art and play! Classes, camps, drop-in play
										time and parties for babies and up.
									</Box>
								</Box>
							</Box>
							<Box display={"flex"} style={{ gap: 16 }}>
								<Avatar
									variant="rounded"
									alt={"persona name"}
									src={
										"https://res.cloudinary.com/liaison-inc/image/upload/s--rIs1yYOM--/c_fill,f_webp,h_400,q_auto,w_400/v1/trustedcare/user-media/prod/approved/provider/655872e3ad2b40198d5966bf/profile/gC90r8KhW/563D9629-C5AB-432B-8EBA-DB107DD1059C.JPG"
									}
									imgProps={{ loading: "lazy", decoding: "async" }}
									style={{ width: 80, height: 80 }}
								>
									AS
								</Avatar>
								<Box
									display={"flex"}
									flexDirection={"column"}
									style={{ gap: 2 }}
								>
									<Box fontWeight={600} fontSize={18} mb={1}>
										Rachel R.
									</Box>

									<Box fontSize={16} lineHeight={1.5}>
										A magical place for families to connect through yoga, art
										and play! Classes, camps, drop-in play time and parties for
										babies and up. A magical place for families to connect
										through yoga, art and play! Classes, camps, drop-in play
										time and parties for babies and up.
									</Box>
								</Box>
							</Box>
						</Box>
					</div>

					<div>
						<Box my={8}>
							<Divider light />
						</Box>
						<Box
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							mb={4}
						>
							<div>
								<Box fontSize={22} fontWeight={600}>
									More times
								</Box>
							</div>
						</Box>
						<List>
							<ListItem
								//key={index}
								button
								//onClick={() => setSelectedOption(option.duration)}
								classes={{
									root: classes.listItem,
									button: classes.listButton,
									container: classes.listItemContainer,
								}}
								disableGutters
							>
								<ListItemText
									classes={{
										primary: classes.listPrimary,
										secondary: classes.listSecondary,
										multiline: classes.listMultiline,
									}}
									primary="Feb 29, 2024 – May 23, 2024"
									secondary={"Thu 10:00 AM – 11:00 AM"}
								/>
								<ListItemSecondaryAction>
									<Button
										size="small"
										disableElevation
										//variant="contained"
										color="secondary"
									>
										View
									</Button>
								</ListItemSecondaryAction>
							</ListItem>
						</List>
					</div>
				</>
			</Box>
		</>
	);
};

ClassAddDetails.propTypes = {};
export default ClassAddDetails;
